import React from "react";
import Icon from "assets/icons";
import Variant from "shared/enums/Variant";
import Button from "shared/components/button";
import ToolTip from "shared/components/tooltip";
import { useCopies } from "shared/hooks/useCopies";
import PurchaseOrderTable from "../purchaseOrderTable";
import { useRegDetail } from "shared/context/regDetail";
import { PurchaseConfirmationPropTypes } from "./types";
import { FooterActions, MessageBody, MessageFooter, MessageHeader, PurchaseStatus } from "./components";

function PurchaseConfirmation(props: PurchaseConfirmationPropTypes) {
  const copies = useCopies();
  const { offlinePaymentNote } = useRegDetail();

  return (
    <React.Fragment>
      <div className="purchaseConfirm">
        <div className="purchaseConfirm_wrapper">
          <div className="purchaseConfirm_tagsWrapper">
            <PurchaseStatus {...props} />
          </div>
          <div className="purchaseConfirm_icon">
            <Icon.CheckMarkOutlineSlim />
          </div>
          <div className="purchaseConfirm_msgWrapper">
            <MessageHeader {...props} />
            <MessageBody {...props} />
          </div>
          {props.purchaseOrder && (
            <PurchaseOrderTable
              {...props.purchaseOrderTableProps}
              purchaseOrder={props.purchaseOrder}
              customFooter={
                props.purchaseOrder.hasRequestedOfflinePayment && offlinePaymentNote ? (
                  <span className="purchaseOrderTable_offlinePaymentDetails printHide">
                    {copies.get("offline.payment.account.details.info.label")}
                    <ToolTip content={offlinePaymentNote} isHTMLFormatted>
                      <Button
                        label={copies.get("view")}
                        variant={Variant.LINK}
                        className="purchaseOrderTable_offlinePaymentDetails--btn"
                      />
                    </ToolTip>
                  </span>
                ) : undefined
              }
            />
          )}
          <MessageFooter {...props} />
        </div>
        <FooterActions {...props} />
      </div>
    </React.Fragment>
  );
}

export default PurchaseConfirmation;
